<template>
  <svg
    class="check-circle-icon"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.375 13.6467L8.67188 16.9064C8.759 17.0365 8.87595 17.144 9.01298 17.2198C9.15002 17.2956 9.30318 17.3376 9.45972 17.3423C9.61626 17.347 9.77166 17.3142 9.91298 17.2467C10.0543 17.1792 10.1774 17.0789 10.2722 16.9542L17.625 7.65137"
      stroke="#2350AC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.45312 12.499C1.45313 15.2962 2.56431 17.9789 4.54223 19.9568C6.52016 21.9347 9.20279 23.0459 12 23.0459C14.7972 23.0459 17.4798 21.9347 19.4578 19.9568C21.4357 17.9789 22.5469 15.2962 22.5469 12.499C22.5469 9.70182 21.4357 7.01918 19.4578 5.04126C17.4798 3.06333 14.7972 1.95215 12 1.95215C9.20279 1.95215 6.52016 3.06333 4.54223 5.04126C2.56431 7.01918 1.45313 9.70182 1.45312 12.499Z"
      stroke="#2350AC"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
